import { c as _c } from "react/compiler-runtime";
import { Icon, TextLink, TextPassage } from '@petsmart-ui/sparky';
import type { LinkBlockProps } from '../types';
import './LinkBlock.scss';
export default function LinkBlock(t0) {
  const $ = _c(13);
  const {
    question,
    answers,
    iconName,
    style
  } = t0;
  let t1;
  if ($[0] !== iconName) {
    t1 = <Icon name={iconName} size="md" />;
    $[0] = iconName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== question) {
    t2 = <TextPassage size="lg">{question}</TextPassage>;
    $[2] = question;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== answers) {
    t3 = answers.map(_temp);
    $[4] = answers;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="tile4-link-block__heading">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== style || $[10] !== t1 || $[11] !== t4) {
    t5 = <div className="tile4-link-block" style={style}>{t1}{t4}</div>;
    $[9] = style;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(t0) {
  const {
    link,
    actionText,
    sysId
  } = t0;
  return <TextLink href={link.webUrl} key={sysId}>{actionText}</TextLink>;
}